/* eslint-disable @typescript-eslint/no-unused-vars */
import { z } from 'zod'

import type { Equal, ExpectTrue } from '../types/validation'

/* TypeScript */
export type TrustpilotWidgetApiProps = {
  technicalName?: string
  title?: string
  subtitle?: string
}

/* Schemas */
export const TrustpilotWidgetApiPropsSchema = z.object({
  technicalName: z.string().optional(),
  title: z.string().optional(),
  subtitle: z.string().optional(),
})

/* Schemas validation */
type TestTrustpilotWidgetProps = ExpectTrue<
  Equal<
    TrustpilotWidgetApiProps,
    z.infer<typeof TrustpilotWidgetApiPropsSchema>
  >
>
